import { render } from "./ChangeMail.vue?vue&type=template&id=c26ec5b6&scoped=true"
import script from "./ChangeMail.vue?vue&type=script&lang=js"
export * from "./ChangeMail.vue?vue&type=script&lang=js"

import "./ChangeMail.vue?vue&type=style&index=0&id=c26ec5b6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c26ec5b6"]])

export default __exports__